// extracted by mini-css-extract-plugin
export default {"modalHeader":"KSRSYsP0p8eUTc6lUFVX","modalHeader2":"WQ4478um2PBvi40XZob6","placeHolderShimmer":"Kz7mzjRZta2lKbErge9Y"};